import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { List, ListItem } from '@design-system/List';
import { linkoutConfigs } from '@/config/routing/LinkoutConfig';

export type SettingsPagePoliciesSectionProps = React.ComponentProps<'div'>;

export const SettingsPagePoliciesSection = ({
  className,
}: SettingsPagePoliciesSectionProps) => {
  const policyLinks = [
    {
      label: 'Terms & Service',
      to: linkoutConfigs.terms,
    },
    {
      label: 'Privacy Policy',
      to: linkoutConfigs.privacy,
    },
    {
      label: 'Copyright Acknowledgement',
      to: linkoutConfigs.copyright,
    },
  ];

  return (
    <div className={cn('flex flex-col', className)}>
      <span className="typography-h2 text-primary mb-6">Policies</span>
      
      <Card>
        <List>
          {policyLinks.map(({ label, to }) => (
            <ListItem key={label} asChild>
              <Link 
                to={to}
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </Link>
            </ListItem>
          ))}
        </List>
      </Card>
    </div>
  );
};